/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientTransferConfirmationAliases {
  BUTTON_FINALIZAR = 'button-finalizar',
  GLOBAL_ACTIONS_CONFIRM = 'global-actions-confirm',
  IMAGE_CONFIRM = 'image-confirm',
  LAYOUT_MAIN = 'layout-main',
  PANEL_CONFIRMATION = 'panel-confirmation',
  TEXT_CONFIRM = 'text-confirm',
}
export { PatientTransferConfirmationAliases };
